import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NavController, NavParams, Platform, ViewController, 
	// AlertController, 
	LoadingController 
} from 'ionic-angular';
import { GoogleMaps, GoogleMap, GoogleMapsEvent, GoogleMapOptions, Marker, 
	HtmlInfoWindow 
} from '@ionic-native/google-maps';
import { Geolocation } from '@ionic-native/geolocation';
import { NativeGeocoder, NativeGeocoderReverseResult, NativeGeocoderOptions } from '@ionic-native/native-geocoder';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { Diagnostic } from '@ionic-native/diagnostic';
import { Subscription }  from 'rxjs/Subscription';
import { DataProvider } from '../../providers/data/data';

 
/**
 * Generated class for the StoreLocatorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-store-locator',
  templateUrl: 'store-locator.html',
})
export class StoreLocatorPage implements OnDestroy  {
  @ViewChild('map_canvas') mapElement: ElementRef;
  map: GoogleMap;

  posLng: any;
  posLat: any;
  posLatLng: any[] = [];

  locEnable: boolean;

  address: any;
  listBranches: any[] = [];
  branchesSub: Subscription;

  latx: any;
  laty: any;

  // info Branch
  _infoBranchName: string;
  _infoBranchAddress: string;
  _infoContactNo: string;

  private resetBackButton: any;


  private baseUrl = 'https://www.google.com/';


  constructor(public navCtrl: NavController, public navParams: NavParams,
  	private geolocation: Geolocation,
		private platform: Platform
		// , private alertCtrl: AlertController
		, private nativeGeocoder: NativeGeocoder 
		, private loadingCtrl: LoadingController
		, private location: LocationAccuracy
		, private diagnostic: Diagnostic
		, private dataProv: DataProvider
		, private viewCtrl: ViewController
		) {

  	// Main LatLng

  	this.posLat = 16.032197;
  	this.posLng = 120.330026;

  	

  }

  ionViewDidLoad() {
  	this.enableLocation();
  	this.loadMap();
  	// this.loadSJD();
	
  }

  ngOnDestroy() {
  	if(this.branchesSub) {
  		this.branchesSub.unsubscribe();
  	}
  }


  onlineCheck() {
  	let loading = this.loadingCtrl.create({
  		content: 'Checking Internet Connection',
  		enableBackdropDismiss: true
  	});

  	loading.present();

    let xhr = new XMLHttpRequest();
    return new Promise((resolve, reject) => {
        xhr.onload = () => {
            loading.dismiss();
            resolve(true);
        };
        xhr.onerror = () => {
            loading.dismiss();
            reject(false);
        };

        xhr.open('GET', this.baseUrl, true);
        xhr.send();
    });
  }


  cancelForm() {
  	this.viewCtrl.dismiss();
  }

  enableLocation() {
    this.location.canRequest().then((canRequest: boolean) => {

			console.log("Requesting EnableLocation Function for  Location");
      if(canRequest) {
        this.location.request(this.location.REQUEST_PRIORITY_HIGH_ACCURACY).then(
        () => { 
          this.getGeoLoc();
					console.log("Getting EnableLocation Function Location");
         },
        error => { 
          this.posLat = 16.032197;
          this.posLng = 120.330026;
          console.log("Set EnableLocation Function Default Location");

        }
        ).catch(() => {
					this.getGeoLoc();
					console.log("Cache EnableLocation Function Geo Location");
        });
      }
      else {
				this.getGeoLoc();
				console.log("Else EnableLocation Function Geo Location");
      }

    });

  }

  getGeoLoc() {
    let lat: any;
    let lon: any;

    this.geolocation.getCurrentPosition().then((resp) => { 
      lat = resp.coords.latitude;
      lon = resp.coords.longitude;

      this.posLat = lat;
      this.posLng = lon;

			// this.getAddr(lat, lon);
			console.log("GetGeoLoc Function getCurPosition");
     
    },
    error => {
    	alert('GetGeoLocation Error encountered: ' + error);
    }).catch((err) => {
    	alert('GetGeoLocation Error encountered: ' + err);
    });
  }


  loadSJD() {
		console.log("Inside loadSJD function");
  	this.listBranches = [];

  	let loadingx = this.loadingCtrl.create({
  		content: 'Loading Stores',
  		enableBackdropDismiss: true
  	});

  	loadingx.present();

  	this.branchesSub = this.dataProv.getBranches()
	.subscribe((rs: any[]) => {
		console.log("loadSJD function getBranches subscribe");
		this.listBranches = rs['data'];

		let sjdPos = this.listBranches.sort((a,b)=>b.s_latilong.localeCompare(a.s_latilong));

		let ico = {
	  		url: 'assets/imgs/sjd_pin.png',
	  		size: {
	  			width: 35,
	  			height: 40
	  		}
	  	}

	  	for(var i = 0; i < sjdPos.length; i++) {
				console.log("loadSJD function getBranches Inside For " + i + "/" + sjdPos.length);
	  		let ss: string  = sjdPos[i].s_latilong;
	  		let ssB: string = sjdPos[i].s_brncname;

	  		var ss1;

	  		console.log(this.listBranches.length);

	  		// if(ss.length > 0) {
  			var sillyString = ss.substr(1).slice(0, -1);	
  			ss1 = sillyString.split(',');	
	  		// }
				if(ss == ""){
					console.log("Empty Location");
				}
				else{
					if(ss1.length > 0) {
						this.latx = ss1[0].substr(4, ss1[0].length).trim();	
						this.laty = ss1[1].substr(5, ss1[1].length).trim();		

					// console.log(this.latx);
					// console.log(this.laty);


						let htmlInfoWindow = new HtmlInfoWindow();
						let frame: HTMLElement = document.createElement('div');
						frame.innerHTML = [
						'<div style="font-size: 15px; font-weight-bold; background-color: #026434; color: #fff; padding: 5px; width: 100%">'+ ssB.toUpperCase() +'</div><hr>',
						'<table style="width: 100%"><tr><td valign="top" style="background-color: lightgray; padding: 3px">Address:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_brncaddr +'</td>',
						'</tr><tr><td valign="top" style="background-color: lightgray; padding: 3px;">Schedule:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_schedule +'</td>',
						'</tr><tr><td valign="top" style="background-color: lightgray; padding: 3px">Contact No:</td><td valign="top" style="padding: 3px;">'+ sjdPos[i].s_contnmbr +'</td></tr></table><hr>'
						// '<hr><span>Address: '+ sjdPos[i].address +'</span><br><span>Schedule: '+ sjdPos[i].schedule +'</span><br><span>Contact No.: '+ sjdPos[i].contactno +'</span>'
					].join("");
					//console.log(ssB.toUpperCase() + " ---- " + sjdPos[i].s_brncaddr + " ---- "+ sjdPos[i].s_schedule + " ---- " +  sjdPos[i].s_contnmbr );
					htmlInfoWindow.setContent(frame, { width: "230px", height: "190px" });
					console.log("Before Error Marker?");
						this.map.addMarker({
							// title: sjdPos[i].s_brncname,
							icon: ico,
							animation: 'DROP',
							position: {
								lat: this.latx,
								lng: this.laty,
							} 
						}).then((marker: Marker) => {
							console.log("Error Marker?");
/* 							marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
								// marker.setTitle(sjdPos[i].s_brncname);
								// marker.showInfoWindow();
								htmlInfoWindow.open(marker);
								
							}); */

							marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
								htmlInfoWindow.open(marker);
							});

							//loadingx.dismiss();
						});
						//console.log("loadSJD function getBranches For Loop IF Statement");
					} else { 
						console.log('no coordinates'); 
						console.log("loadSJD function getBranches For Loop ELSE Statement");
						loadingx.dismiss(); 
					}
				}
	  		
	  	}

	  	

	}, 
	error => {
		loadingx.dismiss();
		alert('Slow Connection: Cannot Load SJD Store due to slow connection');
	},
	function() {
		loadingx.dismiss();
	});
	

  }

  loadMap() {

		console.log("loadMap function");
  	let lat: any;
	let lng: any;

	// let map2: GoogleMap;
	let loading = this.loadingCtrl.create({
		content: 'Loading Map',
		enableBackdropDismiss: true
	});

	loading.present();

  	this.diagnostic.isLocationEnabled().then((val) => {
  		if(val) {
				console.log("loadMap function IF Statement VAL is TRUE");
  			// alert(val);
  			this.geolocation.getCurrentPosition().then((resp) => {
				lat = resp.coords.latitude;
				lng = resp.coords.longitude;

				this.posLat = lat;
				this.posLng = lng;

				let mapOptions: GoogleMapOptions = {
			      camera: {
			         target: {
			           lat: lat,
			           lng: lng
			         },
			         zoom: 10
			       },
			       mapType: 'MAP_TYPE_ROADMAP'
			    };

			    let element = this.mapElement.nativeElement;
			  	
				this.map  = GoogleMaps.create(element, mapOptions);

			  	this.map.one(GoogleMapsEvent.MAP_READY).then(() => {
			  		this.loadSJD();
			  		this.getAddress(lat, lng);
						console.log("loadMap function IF Statement VAL is TRUE > MAP READY");
			  		this.map.addMarker({
					  title: this.address,
				      icon: 'red',
				      animation: 'DROP',
				      position: {
				        lat: lat,
				        lng: lng
				      }
				    }).then((marker: Marker) => {
					  	marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
					  	marker.setTitle(this.address);
							marker.showInfoWindow();
							console.log("loadMap function IF Statement VAL is TRUE > MAP READY >THEN MARKER");
				  		  
					    });
					});

					loading.dismiss();
				  
				    // loading.dismiss();

			  	}).catch((err)=> {
			  		alert('Please check your mobile or wifi connection to show map ' + err);
			  		console.log(err);
			  		loading.dismiss();
						// loading.dismiss();
						console.log("loadMap IF Statement VAL is TRUE > MAP READY >CATCHE ERROR MARKER");
			  	});


			}).catch((error) => {
				// alert(error);
				console.log('Error getting location', error);
				loading.dismiss();
				
			});
  		}
  		
  		// GPS Location not enabled
  		else {
				console.log("loadMap function ELSE VAL FALSE");
  			lat = this.posLat;
  			lng = this.posLng;

  			let mapOptions: GoogleMapOptions = {
		      camera: {
		         target: {
		           lat: lat,
		           lng: lng
		         },
		         zoom: 10
		       },
		       mapType: 'MAP_TYPE_ROADMAP'
		    };

		    let element = this.mapElement.nativeElement;
		  	
			this.map  = GoogleMaps.create(element, mapOptions);

		  	this.map.one(GoogleMapsEvent.MAP_READY).then(() => {
				
		  		this.loadSJD();
		  		this.getAddress(lat, lng);
					console.log("loadMap function ELSE VAL FALSE > MAP READY");
		  		this.map.addMarker({
				  title: this.address,
			      icon: 'red',
			      animation: 'DROP',
			      position: {
			        lat: lat,
			        lng: lng
			      }
			    }).then((marker: Marker) => {
						
				  	marker.on(GoogleMapsEvent.MARKER_CLICK).subscribe(() => {
				  	marker.setTitle(this.address);
			  		marker.showInfoWindow();
						console.log("loadMap function ELSE VAL FALSE > MAP READY> ADD MARKER THEN");
				    });
				});

				loading.dismiss();
			  
			    // loading.dismiss();

		  	}).catch((err)=> {
		  		alert('Cannot load map. Please make sure you have internet connection' + err);
		  		console.log(err);
					loading.dismiss();
					console.log("loadMap function EnableLOcation Catch");
		  	});
  		}
  	});
  }
 

  getAddress(latx, lngx) {
  	let lat = latx;
  	let lng = lngx;
  	console.log("getAddress function");
  	let options: NativeGeocoderOptions = {
			useLocale: true,
			maxResults: 1
		};

		this.nativeGeocoder.reverseGeocode(lat, lng, options).then((result: NativeGeocoderReverseResult[]) => {
			this.address = result[0].thoroughfare +',' + result[0].locality +', '+ result[0].administrativeArea;
			console.log("getAddress function reverseGeocode");
		}).catch((error) => {
			console.log("getAddress function :" + error);
		});
  }
	
	
  ionViewDidEnter() {
    if (this.resetBackButton) {
      this.resetBackButton();
    }
    this.resetBackButton = this.platform.registerBackButtonAction(null);
  }

  ionViewWillLeave() {
      if (this.resetBackButton) {
        this.resetBackButton();
        this.resetBackButton = null;
      }

      const nodeList = document.querySelectorAll('._gmaps_cdv_');

	    for (let k = 0; k < nodeList.length; ++k) {
	        nodeList.item(k).classList.remove('_gmaps_cdv_');
	    }
      
  }

}



// WEBPACK FOOTER //
// ./src/pages/store-locator/store-locator.ts